
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eTcMK", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("ifBRq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<338e14d641245a40433d692614589cc6>>
 * @relayHash 5b529092e8e7cf6e323eeab66137e3bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8
const $8a780169bce82353$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "resolved"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": v10 /*: any*/ 
            }
        ],
        "type": "InlineComment"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": v10 /*: any*/ 
            }
        ],
        "type": "FooterComment"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentQueryParamsListenerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentQueryParamsListenerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5b529092e8e7cf6e323eeab66137e3bd",
            "id": "c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8",
            "metadata": {},
            "name": "CommentQueryParamsListenerQuery",
            "operationKind": "query",
            "text": "query CommentQueryParamsListenerQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,parentId,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}},...on FooterComment{commentResolveProperties{resolved}}},ancestors{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}}}}}"
        }
    };
}();
$8a780169bce82353$var$node.hash = "d0febae7f259d56d6f03c22fbaa80801";
var $8a780169bce82353$export$2e2bcd8739ae039 = $8a780169bce82353$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $4u5NT = parcelRequire("4u5NT");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $lb2Lp = parcelRequire("lb2Lp");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $7aRa9 = parcelRequire("7aRa9");


var $7W8i8 = parcelRequire("7W8i8");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $8WQTF = parcelRequire("8WQTF");


var $aSsfA = parcelRequire("aSsfA");


var $dPJCf = parcelRequire("dPJCf");


var $jMyy4 = parcelRequire("jMyy4");


var $eTcMK = parcelRequire("eTcMK");


var $1ZGYV = parcelRequire("1ZGYV");

// ---------------------------------------------------------------------------
// Unified GraphQL query (superset of both individual queries)
// Fetches inline fields + footer fields in a single request.
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$CommentQueryParamsListenerQuery = (0, $8a780169bce82353$export$2e2bcd8739ae039);
// ---------------------------------------------------------------------------
// Constants (from ObjectCommentQueryParamsListener)
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$SCROLL_TIMEOUT_MS = 4000;
const $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS = 500;
const $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS = 150;
const $4d5518b698c93929$var$expectedErrorCodes = [
    404
];
const $4d5518b698c93929$export$5e7d3f36c6d6619d = (error)=>{
    const list = error.graphQLErrors;
    if (!Array.isArray(list) || list.length === 0) return false;
    return list.some((e)=>{
        const code = e?.extensions?.code;
        if (code === 'NOT_FOUND') return true;
        const statusCode = e?.extensions?.statusCode;
        if (statusCode == null) return false;
        const n = Number(statusCode);
        return Number.isFinite(n) && $4d5518b698c93929$var$expectedErrorCodes.includes(n);
    });
};
function $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode(isNewFlow, foundComment, legacyData, legacyError) {
    if (isNewFlow) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const t = foundComment?.location?.type;
        return t && t !== 'INLINE' ? 'object' : 'inline';
    }
    const node = legacyData?.comments?.nodes?.[0];
    const t = node?.location?.type;
    if (t && t !== 'INLINE') return 'object';
    // Error with no comment node: location unknown — use object semantics for expected 404s only
    if (legacyError && !node) return $4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError) ? 'object' : 'inline';
    return 'inline';
}
function $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, mode) {
    if (!legacyError) return;
    if (mode === 'inline') {
        // Missing/deleted comment (404 / NOT_FOUND) is expected — do not mark as handled (matches object-listener).
        if (!$4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError)) {
            $4d5518b698c93929$var$logger.error`An error occurred when querying the focused comment status; ${legacyError}`;
            (0, $7Sm4c.markErrorAsHandled)(legacyError);
        }
        return;
    }
    // ObjectCommentQueryParamsListener: log unexpected only; never markErrorAsHandled
    if (!$4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError)) $4d5518b698c93929$var$logger.error`An error occurred when querying the focused object comment status; ${legacyError}`;
}
const $4d5518b698c93929$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
// ---------------------------------------------------------------------------
// Query param hooks
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $4d5518b698c93929$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $4d5518b698c93929$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $4d5518b698c93929$var$useCommentQueryParamsData = (0, $3u0dr.isReactCompilerActiveV2)() ? function useCommentQueryParamsData(t0) {
    const $ = (0, $frIzR.c)(43);
    const { commentId: commentId, contentId: contentId } = t0;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let t1;
    if ($[0] !== pageMode) {
        t1 = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        $[0] = pageMode;
        $[1] = t1;
    } else t1 = $[1];
    const contentStatusFilters = t1;
    const t2 = commentId || "";
    const t3 = contentId || "";
    let t4;
    if ($[2] !== commentId) {
        t4 = !commentId || !(0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false);
        $[2] = commentId;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = {
            skip: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contentStatusFilters || $[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
        t6 = {
            commentId: t2,
            contentId: t3,
            contentStatus: contentStatusFilters,
            options: t5
        };
        $[6] = contentStatusFilters;
        $[7] = t2;
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)(t6);
    const t7 = foundComment?.parentId || "";
    const t8 = contentId || "";
    let t9;
    if ($[11] !== foundComment?.parentId) {
        t9 = !(0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) || !foundComment?.parentId;
        $[11] = foundComment?.parentId;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t9) {
        t10 = {
            skip: t9
        };
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== contentStatusFilters || $[16] !== t10 || $[17] !== t7 || $[18] !== t8) {
        t11 = {
            commentId: t7,
            contentId: t8,
            contentStatus: contentStatusFilters,
            options: t10
        };
        $[15] = contentStatusFilters;
        $[16] = t10;
        $[17] = t7;
        $[18] = t8;
        $[19] = t11;
    } else t11 = $[19];
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)(t11);
    let t12;
    let t13;
    if ($[20] !== commentId) {
        t12 = {
            commentId: commentId
        };
        t13 = !commentId || (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false);
        $[20] = commentId;
        $[21] = t12;
        $[22] = t13;
    } else {
        t12 = $[21];
        t13 = $[22];
    }
    let t14;
    if ($[23] !== t12 || $[24] !== t13) {
        t14 = {
            variables: t12,
            skip: t13
        };
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    const { data: legacyData, loading: legacyLoading, error: legacyError } = (0, $jMyy4.useQueryInterop)($4d5518b698c93929$var$CommentQueryParamsListenerQuery, {
        ...t14,
        __callerPackage__: "@confluence/comments-query-param-handlers"
    });
    const legacyInteropErrorMode = $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false), foundComment, legacyData, legacyError);
    $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, legacyInteropErrorMode);
    let isResolved = undefined;
    let parentId = undefined;
    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
        if (foundComment && !commentError) {
            const loc = foundComment.location;
            if (loc?.type === "INLINE") isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
            else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
            parentId = foundComment.parentId;
        }
    } else if (legacyData && !legacyError) {
        const node = legacyData?.comments?.nodes?.[0];
        const loc_0 = node?.location;
        if (loc_0?.type === "INLINE") isResolved = Boolean(loc_0?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc_0?.commentResolveProperties?.resolved);
        parentId = node?.parentId;
    }
    let t15;
    if ($[26] !== foundComment || $[27] !== legacyData?.comments?.nodes?.[0]) {
        t15 = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment : legacyData?.comments?.nodes?.[0] ?? null;
        $[26] = foundComment;
        $[27] = legacyData?.comments?.nodes?.[0];
        $[28] = t15;
    } else t15 = $[28];
    const rawCommentForReply = t15;
    const t16 = Boolean(commentError);
    const t17 = Boolean(parentError);
    let t18;
    if ($[29] !== commentId || $[30] !== commentLoading || $[31] !== foundComment || $[32] !== isResolved || $[33] !== legacyData || $[34] !== legacyError || $[35] !== legacyLoading || $[36] !== parentComment || $[37] !== parentId || $[38] !== parentLoading || $[39] !== rawCommentForReply || $[40] !== t16 || $[41] !== t17) {
        t18 = {
            commentId: commentId,
            foundComment: foundComment,
            parentComment: parentComment,
            commentLoading: commentLoading,
            commentError: t16,
            parentLoading: parentLoading,
            parentError: t17,
            legacyData: legacyData,
            legacyError: legacyError,
            legacyLoading: legacyLoading,
            isResolved: isResolved,
            parentId: parentId,
            rawCommentForReply: rawCommentForReply
        };
        $[29] = commentId;
        $[30] = commentLoading;
        $[31] = foundComment;
        $[32] = isResolved;
        $[33] = legacyData;
        $[34] = legacyError;
        $[35] = legacyLoading;
        $[36] = parentComment;
        $[37] = parentId;
        $[38] = parentLoading;
        $[39] = rawCommentForReply;
        $[40] = t16;
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    return t18;
} : function useCommentQueryParamsData({ commentId: commentId, contentId: contentId }) {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    // NEW FLOW
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !foundComment?.parentId
        }
    });
    // OLD FLOW — unified query fetches superset of both inline + footer fields
    const { data: legacyData, loading: legacyLoading, error: legacyError } = (0, $jMyy4.useQueryInterop)($4d5518b698c93929$var$CommentQueryParamsListenerQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "@confluence/comments-query-param-handlers"
    });
    const legacyInteropErrorMode = $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), foundComment, legacyData, legacyError);
    $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, legacyInteropErrorMode);
    // Derive isResolved + parentId from whichever flow is active
    let isResolved = undefined;
    let parentId = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (foundComment && !commentError) {
            const loc = foundComment.location;
            if (loc?.type === 'INLINE') isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
            else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
            parentId = foundComment.parentId;
        }
    } else if (legacyData && !legacyError) {
        const node = legacyData?.comments?.nodes?.[0];
        const loc_0 = node?.location;
        if (loc_0?.type === 'INLINE') isResolved = Boolean(loc_0?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc_0?.commentResolveProperties?.resolved);
        parentId = node?.parentId;
    }
    const rawCommentForReply = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : legacyData?.comments?.nodes?.[0] ?? null;
    return {
        commentId: commentId,
        foundComment: foundComment,
        parentComment: parentComment,
        commentLoading: commentLoading,
        commentError: Boolean(commentError),
        parentLoading: parentLoading,
        parentError: Boolean(parentError),
        legacyData: legacyData,
        legacyError: legacyError,
        legacyLoading: legacyLoading,
        isResolved: isResolved,
        parentId: parentId,
        rawCommentForReply: rawCommentForReply
    };
}; // ---------------------------------------------------------------------------
const $4d5518b698c93929$var$InlineCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(66);
    const { commentId: commentId, isArchived: isArchived, rendererRef: rendererRef, flags: flags, data: data } = t0;
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    let t1;
    if ($[0] !== isArchived) {
        t1 = {
            queryArchivedContent: isArchived
        };
        $[0] = isArchived;
        $[1] = t1;
    } else t1 = $[1];
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)(t1);
    const { foundComment: foundComment, parentComment: parentComment } = data;
    let t2;
    bb0: if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) {
                let t3;
                if ($[2] !== location || $[3] !== parentLocation || $[4] !== pid) {
                    t3 = {
                        location: location,
                        parentId: pid,
                        parentLocation: parentLocation
                    };
                    $[2] = location;
                    $[3] = parentLocation;
                    $[4] = pid;
                    $[5] = t3;
                } else t3 = $[5];
                t2 = t3;
                break bb0;
            }
        }
        t2 = undefined;
    } else {
        if (!data.legacyError && !data.legacyLoading && data.legacyData) {
            const node = data.legacyData?.comments?.nodes?.[0];
            const location_0 = node?.location ?? undefined;
            const pid_0 = node?.parentId;
            const parentLocation_0 = node?.ancestors?.[0]?.location ?? undefined;
            let t3;
            if ($[6] !== location_0 || $[7] !== parentLocation_0 || $[8] !== pid_0) {
                t3 = {
                    location: location_0,
                    parentId: pid_0,
                    parentLocation: parentLocation_0
                };
                $[6] = location_0;
                $[7] = parentLocation_0;
                $[8] = pid_0;
                $[9] = t3;
            } else t3 = $[9];
            t2 = t3;
            break bb0;
        }
        t2 = undefined;
    }
    const queryParamData = t2;
    let t3;
    if ($[10] !== queryParamData) {
        t3 = queryParamData || {};
        $[10] = queryParamData;
        $[11] = t3;
    } else t3 = $[11];
    const { location: loc, parentLocation: pLoc } = t3;
    let t4;
    if ($[12] !== loc || $[13] !== pLoc?.inlineMarkerRef || $[14] !== pLoc?.inlineResolveProperties?.resolved) {
        t4 = loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
        $[12] = loc;
        $[13] = pLoc?.inlineMarkerRef;
        $[14] = pLoc?.inlineResolveProperties?.resolved;
        $[15] = t4;
    } else t4 = $[15];
    const queryParamDataExt = t4;
    let t5;
    if ($[16] !== data.legacyData?.comments?.nodes?.[0] || $[17] !== foundComment || $[18] !== queryParamDataExt.annotationId || $[19] !== replyToCommentId || $[20] !== setCurrentlySelectedThreadKey || $[21] !== setReplyToCommentId) {
        t5 = ()=>{
            if (!replyToCommentId) return;
            const rawComment = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment : data.legacyData?.comments?.nodes?.[0];
            if (rawComment) {
                const annotationId = queryParamDataExt?.annotationId;
                if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
                const author = rawComment?.author;
                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
            }
        };
        $[16] = data.legacyData?.comments?.nodes?.[0];
        $[17] = foundComment;
        $[18] = queryParamDataExt.annotationId;
        $[19] = replyToCommentId;
        $[20] = setCurrentlySelectedThreadKey;
        $[21] = setReplyToCommentId;
        $[22] = t5;
    } else t5 = $[22];
    const onReplyToCommentReady = t5;
    let t6;
    if ($[23] !== commentId || $[24] !== onReplyToCommentReady || $[25] !== queryParamData?.parentId || $[26] !== queryParamDataExt || $[27] !== setCurrentlySelectedThreadKey || $[28] !== showCommentsPanel) {
        t6 = ()=>{
            const { annotationId: annotationId_0 } = queryParamDataExt;
            showCommentsPanel({
                openWithView: (0, $3mVfX.ViewValues).OPEN
            });
            const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: "center",
                inline: "center",
                commentId: commentId ?? undefined,
                annotationId: annotationId_0,
                commentType: "INLINE",
                annotationClicked: true,
                expectedView: (0, $3mVfX.ViewValues).OPEN,
                isReply: Boolean(queryParamData?.parentId)
            }).then((success)=>{
                if (!success && mark) {
                    (0, $4u5NT.abortAll)("new_interaction", "focused-comment-scroll");
                    (0, $aHcFH.scrollToElementWithViewingRoom)({
                        element: mark,
                        useInstantScroll: true
                    });
                }
            });
            setCurrentlySelectedThreadKey(annotationId_0 ?? "", (0, $8i27m.CommentType).INLINE);
            (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
            hasHandledCommentLink.current = true;
        };
        $[23] = commentId;
        $[24] = onReplyToCommentReady;
        $[25] = queryParamData?.parentId;
        $[26] = queryParamDataExt;
        $[27] = setCurrentlySelectedThreadKey;
        $[28] = showCommentsPanel;
        $[29] = t6;
    } else t6 = $[29];
    const navigateToActiveInlineComment = t6;
    let t7;
    if ($[30] !== commentId || $[31] !== queryParamData?.parentId || $[32] !== queryParamDataExt.annotationId) {
        t7 = ()=>$4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
                parentId: queryParamData?.parentId,
                annotationId: queryParamDataExt?.annotationId || null,
                commentId: commentId || null
            });
        $[30] = commentId;
        $[31] = queryParamData?.parentId;
        $[32] = queryParamDataExt.annotationId;
        $[33] = t7;
    } else t7 = $[33];
    const tryToFocusAndScrollActiveCommentCallback = t7;
    const t8 = !commentId || !queryParamData || queryParamDataExt.isResolved;
    let t9;
    if ($[34] !== rendererRef || $[35] !== t8 || $[36] !== tryToFocusAndScrollActiveCommentCallback) {
        t9 = {
            callback: tryToFocusAndScrollActiveCommentCallback,
            elementRef: rendererRef,
            skip: t8
        };
        $[34] = rendererRef;
        $[35] = t8;
        $[36] = tryToFocusAndScrollActiveCommentCallback;
        $[37] = t9;
    } else t9 = $[37];
    (0, $1ZGYV.useRetryOnMutation)(t9);
    let t10;
    if ($[38] !== commentId || $[39] !== isCommentNotFound || $[40] !== navigateToActiveInlineComment || $[41] !== onReplyToCommentReady || $[42] !== queryParamData || $[43] !== queryParamDataExt || $[44] !== rendererActions || $[45] !== setCommentContainerToFocus || $[46] !== setCurrentlySelectedThreadKey || $[47] !== showCommentsPanel) {
        t10 = ()=>{
            if (!queryParamData || hasHandledCommentLink.current) return;
            const { location: location_1 } = queryParamData;
            const { annotationId: annotationId_1 } = queryParamDataExt;
            if (location_1) {
                if (queryParamDataExt.isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    if (annotationId_1) {
                        setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                    }
                } else {
                    if (annotationId_1 && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) {
                        if (!rendererActions) return;
                        const annotationExists = rendererActions.getAnnotationMarks()?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                        if (!annotationExists) {
                            setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                            setCommentContainerToFocus(commentId ?? undefined);
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                            });
                            (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                            hasHandledCommentLink.current = true;
                            return;
                        } else if ((0, $6mKj3.expValEquals)("confluence_comment_panel_inlinecomment_qp", "isEnabled", true)) {
                            navigateToActiveInlineComment();
                            return;
                        }
                    } else if (annotationId_1 && !(0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && (0, $6mKj3.expValEquals)("confluence_comment_panel_inlinecomment_qp", "isEnabled", true)) {
                        navigateToActiveInlineComment();
                        return;
                    }
                }
            } else {
                if ((0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) {
                    if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
                }
                if (!rendererActions && (0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) return;
                const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
                if (annotationId_1 && !annotationExists_0 && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                }
                hasHandledCommentLink.current = true;
            }
        };
        $[38] = commentId;
        $[39] = isCommentNotFound;
        $[40] = navigateToActiveInlineComment;
        $[41] = onReplyToCommentReady;
        $[42] = queryParamData;
        $[43] = queryParamDataExt;
        $[44] = rendererActions;
        $[45] = setCommentContainerToFocus;
        $[46] = setCurrentlySelectedThreadKey;
        $[47] = showCommentsPanel;
        $[48] = t10;
    } else t10 = $[48];
    let t11;
    if ($[49] !== commentId || $[50] !== isCommentNotFound || $[51] !== navigateToActiveInlineComment || $[52] !== onReplyToCommentReady || $[53] !== orderedActiveAnnotationIdList || $[54] !== queryParamData || $[55] !== queryParamDataExt || $[56] !== rendererActions || $[57] !== setCommentContainerToFocus || $[58] !== setCurrentlySelectedThreadKey || $[59] !== showCommentsPanel) {
        t11 = [
            queryParamData,
            rendererActions,
            orderedActiveAnnotationIdList,
            queryParamDataExt,
            showCommentsPanel,
            setCurrentlySelectedThreadKey,
            setCommentContainerToFocus,
            commentId,
            isCommentNotFound,
            onReplyToCommentReady,
            navigateToActiveInlineComment
        ];
        $[49] = commentId;
        $[50] = isCommentNotFound;
        $[51] = navigateToActiveInlineComment;
        $[52] = onReplyToCommentReady;
        $[53] = orderedActiveAnnotationIdList;
        $[54] = queryParamData;
        $[55] = queryParamDataExt;
        $[56] = rendererActions;
        $[57] = setCommentContainerToFocus;
        $[58] = setCurrentlySelectedThreadKey;
        $[59] = showCommentsPanel;
        $[60] = t11;
    } else t11 = $[60];
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[61] !== commentId || $[62] !== flags || $[63] !== isCommentNotFound) {
        t12 = ()=>{
            if (isCommentNotFound) flags.showWarningFlag({
                id: `viewpage-comment-link-not-found-${commentId}`,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        };
        t13 = [
            commentId,
            flags,
            isCommentNotFound
        ];
        $[61] = commentId;
        $[62] = flags;
        $[63] = isCommentNotFound;
        $[64] = t12;
        $[65] = t13;
    } else {
        t12 = $[64];
        t13 = $[65];
    }
    (0, $42omo.useEffect)(t12, t13);
    return null;
} : ({ commentId: commentId, isArchived: isArchived, rendererRef: rendererRef, flags: flags, data: data })=>{
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    const { foundComment: foundComment, isResolved: _ignored, parentComment: parentComment } = data;
    const queryParamData = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            if (!data.commentError && !data.commentLoading && foundComment) {
                const location = foundComment.location ?? undefined;
                const pid = foundComment.parentId;
                const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
                if (!pid || parentComment) return {
                    location: location,
                    parentId: pid,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        } else {
            if (!data.legacyError && !data.legacyLoading && data.legacyData) {
                const node = data.legacyData?.comments?.nodes?.[0];
                const location_0 = node?.location ?? undefined;
                const pid_0 = node?.parentId;
                const parentLocation_0 = node?.ancestors?.[0]?.location ?? undefined;
                return {
                    location: location_0,
                    parentId: pid_0,
                    parentLocation: parentLocation_0
                };
            }
            return undefined;
        }
    }, [
        data.commentError,
        data.commentLoading,
        foundComment,
        data.parentError,
        data.parentLoading,
        parentComment,
        data.legacyData,
        data.legacyError,
        data.legacyLoading
    ]);
    const queryParamDataExt = (0, $42omo.useMemo)(()=>{
        const { location: loc, parentLocation: pLoc } = queryParamData || {};
        return loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    const onReplyToCommentReady = (0, $42omo.useCallback)(()=>{
        if (!replyToCommentId) return;
        const rawComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : data.legacyData?.comments?.nodes?.[0];
        if (rawComment) {
            const annotationId = queryParamDataExt?.annotationId;
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
            const author = rawComment?.author;
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
        }
    }, [
        replyToCommentId,
        foundComment,
        data.legacyData,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const navigateToActiveInlineComment = (0, $42omo.useCallback)(()=>{
        const { annotationId: annotationId_0 } = queryParamDataExt;
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
        (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            block: 'center',
            inline: 'center',
            commentId: commentId ?? undefined,
            annotationId: annotationId_0,
            commentType: 'INLINE',
            annotationClicked: true,
            expectedView: (0, $3mVfX.ViewValues).OPEN,
            isReply: Boolean(queryParamData?.parentId)
        }).then((success)=>{
            if (!success && mark) {
                (0, $4u5NT.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        });
        setCurrentlySelectedThreadKey(annotationId_0 ?? '', (0, $8i27m.CommentType).INLINE);
        (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
        hasHandledCommentLink.current = true;
    }, [
        queryParamData,
        queryParamDataExt,
        commentId,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        onReplyToCommentReady
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $42omo.useCallback)(()=>{
        return $4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $42omo.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location_1 } = queryParamData;
        const { annotationId: annotationId_1 } = queryParamDataExt;
        if (location_1) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId_1) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                }
            } else if (annotationId_1 && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                // rendererActions is populated asynchronously — wait for it before checking
                // annotation marks, otherwise we'd incorrectly treat active comments as dangling.
                if (!rendererActions) return;
                // Comment exists in DB but annotation mark may be gone from page content (deleted content).
                // Check if annotation mark exists in renderer; if not, open DELETED_CONTENT panel.
                const annotationExists = rendererActions.getAnnotationMarks()?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                } else if ((0, $6mKj3.expValEquals)('confluence_comment_panel_inlinecomment_qp', 'isEnabled', true)) {
                    // Active inline comment with annotation mark present — open panel and navigate to it.
                    navigateToActiveInlineComment();
                    return;
                }
            } else if (annotationId_1 && !(0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') && (0, $6mKj3.expValEquals)('confluence_comment_panel_inlinecomment_qp', 'isEnabled', true)) {
                // Dangling UX gate is off — still open panel and navigate for active inline comments.
                navigateToActiveInlineComment();
                return;
            }
        } else {
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
            }
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
            if (annotationId_1 && !annotationExists_0 && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(annotationId_1, (0, $8i27m.CommentType).INLINE);
                setCommentContainerToFocus(commentId ?? undefined);
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList,
        queryParamDataExt,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        commentId,
        isCommentNotFound,
        onReplyToCommentReady,
        navigateToActiveInlineComment
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isCommentNotFound) flags.showWarningFlag({
            id: `viewpage-comment-link-not-found-${commentId}`,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
        });
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
// Helper (kept private — only used by InlineCommentHandler)
const $4d5518b698c93929$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $4u5NT.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $4u5NT.abortAll)('new_interaction', 'focused-comment-scroll');
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $4d5518b698c93929$var$ObjectCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, data: data } = t0;
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $42omo.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $42omo.useState)(false);
    const mutationObserverRef = (0, $42omo.useRef)(null);
    const scrollTimeoutRef = (0, $42omo.useRef)(null);
    const lastMutationTimeRef = (0, $42omo.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (scrollTimeoutRef.current !== null) {
                if (typeof scrollTimeoutRef.current === "number") {
                    if (typeof window !== "undefined" && "cancelIdleCallback" in window) window.cancelIdleCallback(scrollTimeoutRef.current);
                } else clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearScrollTimeout = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (mutationObserverRef.current) {
                mutationObserverRef.current.disconnect();
                mutationObserverRef.current = null;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const cleanupMutationObserver = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (mutationObserverRef.current) cleanupMutationObserver();
            if (scrollTimeoutRef.current !== null) clearScrollTimeout();
        };
        $[2] = t3;
    } else t3 = $[2];
    const cleanupScrollResources = t3;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, rawCommentForReply: rawCommentForReply, foundComment: foundComment, legacyData: legacyData, commentError: commentError } = data;
    let t4;
    if ($[3] !== allObjectCommentsRendered || $[4] !== commentError || $[5] !== commentId || $[6] !== commentsDataMap || $[7] !== data.legacyError || $[8] !== focusedCommentId || $[9] !== foundComment || $[10] !== hasLoadedObjectComments || $[11] !== hasScrolledToFocusedComment || $[12] !== hasScrolledToReplyComment || $[13] !== isResolved || $[14] !== legacyData || $[15] !== parentId || $[16] !== processedCommentsData || $[17] !== rawCommentForReply || $[18] !== replyToComment || $[19] !== setCurrentlySelectedThreadKey || $[20] !== setReplyToCommentId || $[21] !== showCommentsPanel) {
        t4 = ()=>{
            const hasData = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment && !commentError : legacyData && !data.legacyError;
            if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                let rootCommentId;
                if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                    if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                } else {
                    const legacyFooterComments = Object.values(commentsDataMap.general);
                    if (legacyFooterComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId)?.id;
                }
                if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
            }
            if (hasData && commentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_queryparam_selection", "isEnabled", true)) {
                const loc = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment?.location : legacyData?.comments?.nodes?.[0]?.location;
                if (loc && "type" in loc && loc.type === "INLINE") return;
            }
            if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
                if (isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                    if (focusedCommentId) setHasScrolledToFocusedComment(true);
                    else setHasScrolledToReplyComment(true);
                } else {
                    const commentElementId = `footer-comment-thread-${commentId}-container`;
                    const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                    let threadToBeSelected = commentId;
                    if (parentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                        let rootCommentId_0;
                        if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                            if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                        } else {
                            const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                            if (legacyFooterComments_0.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId)?.id;
                        }
                        threadToBeSelected = rootCommentId_0 ?? parentId;
                    }
                    if (commentId) {
                        if ((0, $6mKj3.expValEquals)("confluence_comment_deeplink_delay_scroll", "isEnabled", true)) {
                            if (replyToComment) {
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                const author = rawCommentForReply?.author;
                                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true)));
                                setHasScrolledToReplyComment(true);
                                return;
                            }
                            cleanupMutationObserver();
                            const getDocumentScrollHeight = $4d5518b698c93929$var$_temp;
                            const scrollToComment = ()=>{
                                const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (el && (0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) getDocumentScrollHeight();
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                cleanupMutationObserver();
                            };
                            const performScrollAndCleanup = ()=>{
                                clearScrollTimeout();
                                if ((0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                                else scrollToComment();
                            };
                            const checkHeightStabilityThenScroll = ()=>{
                                if (!(0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) {
                                    performScrollAndCleanup();
                                    return;
                                }
                                const h1 = getDocumentScrollHeight();
                                scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    const h2 = getDocumentScrollHeight();
                                    if (h1 === h2) performScrollAndCleanup();
                                    else scheduleScroll();
                                }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                            };
                            const scheduleScroll = ()=>{
                                clearScrollTimeout();
                                lastMutationTimeRef.current = Date.now();
                                if (typeof window !== "undefined" && "requestIdleCallback" in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                    const checkStabilityAndScroll = ()=>{
                                        const timeSince = Date.now() - lastMutationTimeRef.current;
                                        if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                        else scrollTimeoutRef.current = setTimeout(()=>{
                                            scrollTimeoutRef.current = null;
                                            checkStabilityAndScroll();
                                        }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                    };
                                    checkStabilityAndScroll();
                                });
                                else scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            };
                            const getElementAndCheckReady = ()=>{
                                const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (!el_0) return {
                                    element: null,
                                    isReady: false
                                };
                                const rect = el_0.getBoundingClientRect();
                                return {
                                    element: el_0,
                                    isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                                };
                            };
                            const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                            if (currentElement && isReady) scheduleScroll();
                            else {
                                mutationObserverRef.current = new MutationObserver(()=>{
                                    lastMutationTimeRef.current = Date.now();
                                    const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                    if (el_1 && elReady) scheduleScroll();
                                });
                                if (currentElement) {
                                    mutationObserverRef.current.observe(currentElement, {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: [
                                            "style",
                                            "class"
                                        ]
                                    });
                                    const parent = currentElement.parentElement;
                                    if (parent) mutationObserverRef.current.observe(parent, {
                                        childList: true,
                                        subtree: true
                                    });
                                } else mutationObserverRef.current.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                                setTimeout(()=>{
                                    if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            }
                        } else {
                            const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el_2) {
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                            }
                        }
                    }
                }
            }
        };
        $[3] = allObjectCommentsRendered;
        $[4] = commentError;
        $[5] = commentId;
        $[6] = commentsDataMap;
        $[7] = data.legacyError;
        $[8] = focusedCommentId;
        $[9] = foundComment;
        $[10] = hasLoadedObjectComments;
        $[11] = hasScrolledToFocusedComment;
        $[12] = hasScrolledToReplyComment;
        $[13] = isResolved;
        $[14] = legacyData;
        $[15] = parentId;
        $[16] = processedCommentsData;
        $[17] = rawCommentForReply;
        $[18] = replyToComment;
        $[19] = setCurrentlySelectedThreadKey;
        $[20] = setReplyToCommentId;
        $[21] = showCommentsPanel;
        $[22] = t4;
    } else t4 = $[22];
    let t5;
    if ($[23] !== allObjectCommentsRendered || $[24] !== commentBatchCount || $[25] !== commentBatchRendered || $[26] !== commentError || $[27] !== commentId || $[28] !== commentsDataMap || $[29] !== data.legacyError || $[30] !== focusedCommentId || $[31] !== foundComment || $[32] !== hasLoadedObjectComments || $[33] !== hasScrolledToFocusedComment || $[34] !== hasScrolledToReplyComment || $[35] !== isResolved || $[36] !== legacyData || $[37] !== parentId || $[38] !== processedCommentsData || $[39] !== rawCommentForReply || $[40] !== replyToComment || $[41] !== setCurrentlySelectedThreadKey || $[42] !== setReplyToCommentId || $[43] !== showCommentsPanel) {
        t5 = [
            legacyData,
            data.legacyError,
            foundComment,
            commentError,
            hasLoadedObjectComments,
            commentId,
            focusedCommentId,
            replyToComment,
            allObjectCommentsRendered,
            commentBatchRendered,
            commentBatchCount,
            setCurrentlySelectedThreadKey,
            setReplyToCommentId,
            isResolved,
            showCommentsPanel,
            hasScrolledToFocusedComment,
            hasScrolledToReplyComment,
            rawCommentForReply,
            parentId,
            processedCommentsData,
            commentsDataMap,
            cleanupScrollResources,
            cleanupMutationObserver,
            clearScrollTimeout
        ];
        $[23] = allObjectCommentsRendered;
        $[24] = commentBatchCount;
        $[25] = commentBatchRendered;
        $[26] = commentError;
        $[27] = commentId;
        $[28] = commentsDataMap;
        $[29] = data.legacyError;
        $[30] = focusedCommentId;
        $[31] = foundComment;
        $[32] = hasLoadedObjectComments;
        $[33] = hasScrolledToFocusedComment;
        $[34] = hasScrolledToReplyComment;
        $[35] = isResolved;
        $[36] = legacyData;
        $[37] = parentId;
        $[38] = processedCommentsData;
        $[39] = rawCommentForReply;
        $[40] = replyToComment;
        $[41] = setCurrentlySelectedThreadKey;
        $[42] = setReplyToCommentId;
        $[43] = showCommentsPanel;
        $[44] = t5;
    } else t5 = $[44];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasScrolledToFocusedComment(false);
            setHasScrolledToReplyComment(false);
            cleanupScrollResources();
        };
        $[45] = t6;
    } else t6 = $[45];
    let t7;
    if ($[46] !== focusedCommentId || $[47] !== replyToComment) {
        t7 = [
            focusedCommentId,
            replyToComment,
            cleanupScrollResources
        ];
        $[46] = focusedCommentId;
        $[47] = replyToComment;
        $[48] = t7;
    } else t7 = $[48];
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>()=>cleanupScrollResources();
        t9 = [
            cleanupScrollResources
        ];
        $[49] = t8;
        $[50] = t9;
    } else {
        t8 = $[49];
        t9 = $[50];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[51] !== focusedCommentId || $[52] !== hasLoadedObjectComments || $[53] !== replyToComment || $[54] !== setForceLoadComments) {
        t10 = ()=>{
            if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
        };
        t11 = [
            focusedCommentId,
            replyToComment,
            hasLoadedObjectComments,
            setForceLoadComments
        ];
        $[51] = focusedCommentId;
        $[52] = hasLoadedObjectComments;
        $[53] = replyToComment;
        $[54] = setForceLoadComments;
        $[55] = t10;
        $[56] = t11;
    } else {
        t10 = $[55];
        t11 = $[56];
    }
    (0, $42omo.useEffect)(t10, t11);
    return null;
} : ({ commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, data: data })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $42omo.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $42omo.useState)(false);
    const mutationObserverRef = (0, $42omo.useRef)(null);
    const scrollTimeoutRef = (0, $42omo.useRef)(null);
    const lastMutationTimeRef = (0, $42omo.useRef)(0);
    const clearScrollTimeout = (0, $42omo.useCallback)(()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) window.cancelIdleCallback(scrollTimeoutRef.current);
            } else clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    }, []);
    const cleanupMutationObserver = (0, $42omo.useCallback)(()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    }, []);
    const cleanupScrollResources = (0, $42omo.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, [
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, rawCommentForReply: rawCommentForReply, foundComment: foundComment, legacyData: legacyData, commentError: commentError } = data;
    // Update currentlySelectedThreadKey to root comment for replies (after scroll)
    (0, $42omo.useEffect)(()=>{
        const hasData = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment && !commentError : legacyData && !data.legacyError;
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
            } else {
                const legacyFooterComments = Object.values(commentsDataMap.general);
                if (legacyFooterComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId)?.id;
            }
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if this is actually an INLINE comment — handled by InlineCommentHandler
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const loc = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment?.location : legacyData?.comments?.nodes?.[0]?.location;
            if (loc && 'type' in loc && loc.type === 'INLINE') return;
        }
        if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    let rootCommentId_0;
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                    } else {
                        const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                        if (legacyFooterComments_0.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId)?.id;
                    }
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            const author = rawCommentForReply?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                el.offsetTop;
                                getDocumentScrollHeight();
                            }
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                            else scrollToComment();
                        };
                        const checkHeightStabilityThenScroll = ()=>{
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            lastMutationTimeRef.current = Date.now();
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSince = Date.now() - lastMutationTimeRef.current;
                                    if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                    else scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                };
                                checkStabilityAndScroll();
                            });
                            else scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        };
                        const getElementAndCheckReady = ()=>{
                            const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!el_0) return {
                                element: null,
                                isReady: false
                            };
                            const rect = el_0.getBoundingClientRect();
                            return {
                                element: el_0,
                                isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            mutationObserverRef.current = new MutationObserver(()=>{
                                lastMutationTimeRef.current = Date.now();
                                const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                if (el_1 && elReady) scheduleScroll();
                            });
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parent = currentElement.parentElement;
                                if (parent) mutationObserverRef.current.observe(parent, {
                                    childList: true,
                                    subtree: true
                                });
                            } else mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        }
                    } else {
                        const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                        if (el_2) {
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                        }
                    }
                }
            }
        }
    }, [
        legacyData,
        data.legacyError,
        foundComment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        rawCommentForReply,
        parentId,
        processedCommentsData,
        commentsDataMap,
        cleanupScrollResources,
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    (0, $42omo.useEffect)(()=>()=>cleanupScrollResources(), [
        cleanupScrollResources
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
    }, [
        focusedCommentId,
        replyToComment,
        hasLoadedObjectComments,
        setForceLoadComments
    ]);
    return null;
};
const $4d5518b698c93929$export$c21fa150171418d7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { isArchived: t1, rendererRef: rendererRef, hasLoadedObjectComments: t2, allObjectCommentsRendered: t3, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, flags: flags } = t0;
    const isArchived = t1 === undefined ? false : t1;
    const hasLoadedObjectComments = t2 === undefined ? false : t2;
    const allObjectCommentsRendered = t3 === undefined ? false : t3;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t4;
    if ($[0] !== isArchived) {
        t4 = {
            queryArchivedContent: isArchived
        };
        $[0] = isArchived;
        $[1] = t4;
    } else t4 = $[1];
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)(t4);
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    let t5;
    if ($[2] !== commentId || $[3] !== contentId) {
        t5 = {
            commentId: commentId,
            contentId: contentId
        };
        $[2] = commentId;
        $[3] = contentId;
        $[4] = t5;
    } else t5 = $[4];
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData(t5);
    const commentLocationType = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? sharedData.foundComment?.location?.type : sharedData.legacyData?.comments?.nodes?.[0]?.location?.type;
    const isInlineComment = !commentLocationType || commentLocationType === "INLINE";
    if (isInlineComment && rendererRef) {
        let t6;
        if ($[5] !== commentId || $[6] !== flags || $[7] !== isArchived || $[8] !== rendererRef || $[9] !== sharedData) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
                commentId: commentId,
                isArchived: isArchived,
                rendererRef: rendererRef,
                flags: flags,
                data: sharedData
            });
            $[5] = commentId;
            $[6] = flags;
            $[7] = isArchived;
            $[8] = rendererRef;
            $[9] = sharedData;
            $[10] = t6;
        } else t6 = $[10];
        return t6;
    }
    if (!isInlineComment && setForceLoadComments) {
        const t6 = focusedCommentIdQP || inlineFocusedId;
        const t7 = replyToCommentQP || replyToCommentId;
        let t8;
        if ($[11] !== allObjectCommentsRendered || $[12] !== commentBatchCount || $[13] !== commentBatchRendered || $[14] !== commentId || $[15] !== hasLoadedObjectComments || $[16] !== setForceLoadComments || $[17] !== sharedData || $[18] !== t6 || $[19] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
                commentId: commentId,
                focusedCommentId: t6,
                replyToComment: t7,
                hasLoadedObjectComments: hasLoadedObjectComments,
                allObjectCommentsRendered: allObjectCommentsRendered,
                commentBatchRendered: commentBatchRendered,
                commentBatchCount: commentBatchCount,
                setForceLoadComments: setForceLoadComments,
                data: sharedData
            });
            $[11] = allObjectCommentsRendered;
            $[12] = commentBatchCount;
            $[13] = commentBatchRendered;
            $[14] = commentId;
            $[15] = hasLoadedObjectComments;
            $[16] = setForceLoadComments;
            $[17] = sharedData;
            $[18] = t6;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    return null;
} : ({ isArchived: isArchived = false, rendererRef: rendererRef, hasLoadedObjectComments: hasLoadedObjectComments = false, allObjectCommentsRendered: allObjectCommentsRendered = false, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Inline query params (used for InlineCommentHandler + shared commentId)
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    // Object query params
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    // Unified commentId: prefer inline params, fall back to object params
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    // Single shared data fetch — one query for all comment types
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData({
        commentId: commentId,
        contentId: contentId
    });
    // Determine comment type from data (new or old flow)
    const commentLocationType = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? sharedData.foundComment?.location?.type : sharedData.legacyData?.comments?.nodes?.[0]?.location?.type;
    // Treat undefined (not yet loaded) as INLINE to satisfy InlineCommentHandler
    // which handles the "not found" case. Once loaded, route based on actual type.
    const isInlineComment = !commentLocationType || commentLocationType === 'INLINE';
    if (isInlineComment && rendererRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
        commentId: commentId,
        isArchived: isArchived,
        rendererRef: rendererRef,
        flags: flags,
        data: sharedData
    });
    if (!isInlineComment && setForceLoadComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
        commentId: commentId,
        focusedCommentId: focusedCommentIdQP || inlineFocusedId,
        replyToComment: replyToCommentQP || replyToCommentId,
        hasLoadedObjectComments: hasLoadedObjectComments,
        allObjectCommentsRendered: allObjectCommentsRendered,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        setForceLoadComments: setForceLoadComments,
        data: sharedData
    });
    return null;
};
const $4d5518b698c93929$export$d7e13e4fc19ecc08 = (0, $7aRa9.withFlags)($4d5518b698c93929$export$c21fa150171418d7);
function $4d5518b698c93929$var$_temp() {
    return Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
}
module.exports["CommentQueryParamsListener"] = $4d5518b698c93929$export$d7e13e4fc19ecc08;

});

parcelRegister("1ZGYV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION = 20000;
const $b6108840e0d320f3$var$USER_INTERACTION_EVENTS = [
    'mousedown',
    'keydown',
    'wheel',
    'touchstart'
];
const $b6108840e0d320f3$export$544875121493f258 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { callback: callback, elementRef: elementRef, skip: skip } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const stopObserverCallbacks = (0, $42omo.useRef)(t1);
    const mutationEndTimer = (0, $42omo.useRef)(0);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (_reason)=>{
            stopObserverCallbacks.current.forEach($b6108840e0d320f3$var$_temp);
            stopObserverCallbacks.current = [];
            if (mutationEndTimer.current !== 0) {
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = 0;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const stopMonitoring = t2;
    let t3;
    if ($[2] !== callback || $[3] !== elementRef) {
        t3 = ()=>{
            if (!stopObserverCallbacks.current.length && elementRef?.current) {
                const mutationObserver = new MutationObserver(()=>{
                    window.clearTimeout(mutationEndTimer.current);
                    mutationEndTimer.current = window.setTimeout(()=>{
                        stopMonitoring("Deep link target never found");
                    }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                    if (callback()) stopMonitoring("Callback succeeded");
                });
                mutationObserver.observe(elementRef.current, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                stopObserverCallbacks.current.push(()=>{
                    mutationObserver.disconnect();
                });
                $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                    const userInteractionHandler = ()=>stopMonitoring("User interaction");
                    window.addEventListener(name, userInteractionHandler, true);
                    stopObserverCallbacks.current.push(()=>{
                        window.removeEventListener(name, userInteractionHandler, true);
                    });
                });
            }
        };
        $[2] = callback;
        $[3] = elementRef;
        $[4] = t3;
    } else t3 = $[4];
    const startMonitoring = t3;
    let t4;
    let t5;
    if ($[5] !== callback || $[6] !== elementRef || $[7] !== skip || $[8] !== startMonitoring) {
        t4 = ()=>{
            if (skip || !elementRef?.current) return;
            if (callback()) return;
            startMonitoring();
            return ()=>{
                stopMonitoring("Canceled by unmount");
            };
        };
        t5 = [
            elementRef,
            callback,
            skip,
            startMonitoring,
            stopMonitoring
        ];
        $[5] = callback;
        $[6] = elementRef;
        $[7] = skip;
        $[8] = startMonitoring;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
} : ({ callback: callback, elementRef: elementRef, skip: skip })=>{
    const stopObserverCallbacks = (0, $42omo.useRef)([]);
    const mutationEndTimer = (0, $42omo.useRef)(0);
    const stopMonitoring = (0, $42omo.useCallback)((_reason)=>{
        stopObserverCallbacks.current.forEach((stop)=>{
            stop();
        });
        stopObserverCallbacks.current = [];
        if (mutationEndTimer.current !== 0) {
            window.clearTimeout(mutationEndTimer.current);
            mutationEndTimer.current = 0;
        }
    }, []);
    const startMonitoring = (0, $42omo.useCallback)(()=>{
        if (!stopObserverCallbacks.current.length && elementRef?.current) {
            const mutationObserver = new MutationObserver(()=>{
                // Every time there's a change, restart the timer that ends watching for mutations
                // (keep the observer going until changes stop for a while).
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = window.setTimeout(()=>{
                    // De-bouncing ended. Timeout finally running, time to stop observing and trying to follow the anchor
                    stopMonitoring('Deep link target never found');
                }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                if (callback()) // If the callback succeeded, stop monitoring
                stopMonitoring('Callback succeeded');
            });
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
            stopObserverCallbacks.current.push(()=>{
                mutationObserver.disconnect();
            });
            // Listen for user interaction to end checking for changes
            $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                const userInteractionHandler = ()=>stopMonitoring('User interaction');
                window.addEventListener(name, userInteractionHandler, true);
                stopObserverCallbacks.current.push(()=>{
                    window.removeEventListener(name, userInteractionHandler, true);
                });
            });
        }
    }, [
        elementRef,
        callback,
        stopMonitoring
    ]);
    (0, $42omo.useEffect)(()=>{
        // Do nothing if skip is true or the elementRef is not set.
        if (skip || !elementRef?.current) return;
        // Try right away in case the page has already settled and there are no mutations to observe.
        if (callback()) return;
        // Watch for changes to the page and call the callback whenever one occurs.
        startMonitoring();
        return ()=>{
            stopMonitoring('Canceled by unmount');
        };
    }, [
        elementRef,
        callback,
        skip,
        startMonitoring,
        stopMonitoring
    ]);
};
function $b6108840e0d320f3$var$_temp(stop) {
    stop();
}
module.exports["useRetryOnMutation"] = $b6108840e0d320f3$export$544875121493f258;

});


//# sourceMappingURL=ObjectCommentContainer.59993aed.js.map
